import { actions, reducer } from './reducer';
import * as selectors from './selectors';
import { supportWorker } from './saga';
export const supportModel = { actions, reducer, selectors, saga: supportWorker };
